<template>
    <div :style="{'max-width': '95%', 'width': '95%', 'margin-left': 'auto', 'margin-right': 'auto', 'margin-top': '10px'}">
        <b-card-text><h3>CUSTOMER SERVICE</h3></b-card-text>

        <b-alert show variant="secondary" style="border: 1px dashed;">
            <div><h4>CREATE NEW TICKET</h4></div>
            <div style="display: inline-block; vertical-align: top; width: 300px;">
                <b-input v-model="search_query" placeholder="INVOICE # OR NAME OR PHONE" @keyup.enter="find_invoices_for_cs"></b-input>
            </div>
            <div style="display: inline-block; vertical-align: top; width: 200px;">
                <b-button @click="find_invoices_for_cs">FIND</b-button>
            </div>

            <!-- Enhanced Invoice View Section -->
            <div style="margin-top: 15px; padding: 5px;" v-if="selected_invoice">
                <div class="invoice-header" style="background: #f8f9fa; padding: 10px; border-radius: 5px; margin-bottom: 15px;">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div>
                            <h4>INVOICE # <b>{{selected_invoice.invoice_id}}</b></h4>
                            <div>SOLD AT: <b>{{selected_invoice.ts}}</b></div>
                            <div>CUSTOMER: <b>{{selected_invoice.customer_fullname}}</b></div>
                        </div>
                        <div>
                            <b-button size="sm" variant="outline-secondary" @click="selected_invoice = null">Close View</b-button>
                        </div>
                    </div>
                </div>
                
                <!-- Full Invoice View Component -->
                <ViewSale2 :viewdata="selected_invoice" />
            </div>

            <!-- Original Search Results Summary -->
            <div style="margin-top: 5px; padding: 5px;" v-if="searched_invoices.length > 0 && !selected_invoice">
                <div v-for="sitem,sidx in searched_invoices" v-bind:key="sidx" style="margin-top: 5px;">
                    <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
                        <div>
                            <b-button size="sm" variant="primary" @click="showFullInvoice(sitem)">
                                View Full Invoice
                            </b-button>
                        </div>
                        <div>
                            <div style="display: inline-block; border: 1px solid; padding: 3px;">INVOICE # <b>{{sitem.invoice_id}}</b></div>
                            <div style="display: inline-block; border: 1px solid; padding: 3px;"> SOLD AT <b>{{sitem.ts}}</b></div>
                            <div style="display: inline-block; border: 1px solid; padding: 3px;"> CUSTOMER <b>{{sitem.customer_fullname}}</b></div>
                        </div>
                    </div>
                    
                    <div style="overflow-x: auto; width: 100%;">
                        <table style="width: 100%;">
                            <thead>
                                <tr>
                                    <td class="ipt_tdhr" style="width: 200px;">GROUP</td>
                                    <td class="ipt_tdhr" style="width: 250px;">PRODUCT</td>
                                    <td class="ipt_tdhr" style="width: 250px;">QUANTITY</td>
                                    <td class="ipt_tdhr" style="width: 200px;">STATE</td>
                                    <td class="ipt_tdhr" style="width: 250px;">ACTION</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="sp, spidx in sitem.items" v-bind:key="spidx">
                                    <td class="ipt_tdr">{{sp.parent_product_sku}}</td>
                                    <td class="ipt_tdr">{{sp.product_sku}}</td>
                                    <td class="ipt_tdr">{{sp.quantity}}</td>
                                    <td class="ipt_tdr">{{sp.state}}</td>
                                    <td class="ipt_tdr">
                                        <b-button size="sm" variant="success" @click="create_new_from_sp(sitem.invoice_id, sp)">CREATE TICKET</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </b-alert>

        <!-- <b-alert show variant="secondary" style="border: 1px dashed; margin-top: 10px;">
            <div><h4>EXISTING TICKETS</h4></div>
            <div show variant="transparent">
                <div style="border: 0px; display: inline-block; vertical-align: top; width: 80%;">
                    <div>FILTER BY STATUS</div>
                    <b-form-select :options="list_options" v-on:change="fetch_items" style="width: 200px;" v-model="list_option_type">
                    </b-form-select>
                </div>
            </div>

            <div style="margin-top: 10px;">
                <b-overlay :show="items_being_loaded" spinner-variant="primary" spinner-type="grow" spinner-small rounded="sm">
                    <div v-if="items.length > 0" style="overflow-x: auto;">
                        <table style="width: 100%;">
                            <thead>
                                <tr style="background: slategray; color: white;">
                                    <th class="ipt_tdhr" style="min-width: 50px;">#</th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('created_on')">CREATED ON</th>
                                    <th class="ipt_tdhr" style="min-width: 100px;" @click="sortby('claim_date')">CLAIM DATE</th>
                                    <th class="ipt_tdhr" style="min-width: 120px;" @click="sortby('invoice_id')">INVOICE</th>
                                    <th class="ipt_tdhr" style="min-width: 250px;" @click="sortby('product_sku')">PRD</th>
                                    <th class="ipt_tdhr" style="min-width: 120px;" @click="sortby('scheduled_date')">SCHDLD DATE</th>
                                    <th class="ipt_tdhr" style="min-width: 120px;" @click="sortby('status')">STATUS</th>
                                    <th class="ipt_tdhr" style="min-width: 200px;" @click="sortby('action')">ACTION</th>
                                    <th class="ipt_tdhr">VIEW</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item, idx in items" :style="{background: 'white'}">
                                    <td class="ipt_tdr">{{ idx + 1 }}</td>
                                    <td class="ipt_tdr">{{ item.created_on }}</td>
                                    <td class="ipt_tdr">{{ item.claim_date }}</td>
                                    <td class="ipt_tdr">{{ item.invoice_id }}</td>
                                    <td class="ipt_tdr">{{ item.product_sku }}</td>
                                    <td class="ipt_tdr">{{ item.scheduled_date }}</td>
                                    <td class="ipt_tdr">
                                        <b-form-select :options="list_options" v-model="item.status" :disabled="true" style="width: 100px; font-size: 12px;"></b-form-select>
                                    </td>
                                    <td class="ipt_tdr">
                                        <b-form-select :options="action_types" v-model="item.action" :disabled="true" style="width: 300px; font-size: 12px;"></b-form-select>
                                    </td>
                                    <td class="ipt_tdr">
                                        <b-button size="sm" variant="primary" @click="view_ticket(item)">VIEW</b-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        <b-alert variant="warning" show style="margin: 0px;">Nothing to show</b-alert>
                    </div>
                </b-overlay>
            </div>
        </b-alert> -->

        <b-modal id="modal-cs-ticket" scrollable title="TICKET" size="lg" hide-footer>
            <CustomerServiceTicket :viewdata="item_data" />
        </b-modal>
    </div>
</template>

<script>
    import moment from 'moment'
    import global_vars from '@/utilities/global_vars'
    import mappings from '@/utilities/mappings'
    import Backer from '@/components/globals/Backer'
    import Requestor from '@/utilities/Requestor'
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    import CustomerServiceTicket from "@/components/CustomerService/CustomerServiceTicket"
    import ViewSale2 from "@/components/Sales/ViewSale2"

    export default {
        name: "CreateCustomerServiceTickets",
        props: [],
        components: {Backer, flatPickr, CustomerServiceTicket, ViewSale2},
        data: function(){
            return {
                items: [],
                items_being_loaded: false,
                packet: {},
                global_vars: global_vars,
                list_options: [
                    {value: "open", text: "OPEN"},
                    {value: "pending", text: "PENDING"},
                    {value: "closed", text: "CLOSED"},
                    {value: "all", text: "ALL"}
                ],
                list_option_type: "all",
                item_data: {},
                searched_invoices: [],
                selected_invoice: null, // Store the selected invoice for full view
                search_query: null,
                action_types: [
                    {value: "exchange", text: "EXCHANGE"},
                    {value: "repair_at_ch", text: "REPAIR AT CUSTOMER HOUSE"},
                    {value: "repair_at_wh", text: "REPAIR AT WAREHOUSE"},
                    {value: "order_parts_with_mfg", text: "ORDER PART WITH MFG"},
                    {value: "not_covered", text: "Not Covered"},
                    {value: "covered_under_extended_warranty", text: "COVERED UNDER EXTENDED WARRANTY"},
                ],
                states_dict: mappings.states_dict,
                sort_asc: null,
            }
        },
        methods: {
            showFullInvoice: function(invoiceSummary) {
                // Fetch the complete invoice details
                this.fetchFullInvoice(invoiceSummary.invoice_id);
            },
            
            fetchFullInvoice: function(invoiceId) {
                let that = this;
                let path = "/api/sales/get_invoice/";
                let data = { invoice_id: invoiceId };
                
                let s = function(response) {
                    if (response.data.result) {
                        that.selected_invoice = response.data.result;
                    } else {
                        that.$bvToast.toast(
                            response.data.error || "Error loading invoice details.",
                            {title: "Error", autoHideDelay: 1500, variant: "warning"}
                        );
                    }
                };
                
                let f = function(error) {
                    console.log(error);
                    that.$bvToast.toast(
                        "Error loading invoice details.",
                        {title: "Error", autoHideDelay: 1500, variant: "warning"}
                    );
                };
                
                Requestor.postAsyncP(path, data, this, s, f);
            },
            
            create_new_from_sp: function(invoice_id, item){
                this.item_data = {}
                this.item_data.invoice_id = invoice_id;
                this.item_data.product_sku = item.product_sku;
                this.item_data.itemid = item.itemid;
                this.$bvModal.show("modal-cs-ticket");
            },
            
            create_new: function(){
                this.item_data = {}
                this.$bvModal.show("modal-cs-ticket");
            },
            
            view_ticket: function(item){
                let id = item.id;
                this.item_data = {id: id}
                this.$bvModal.show("modal-cs-ticket");
            },
            
            find_invoices_for_cs: function(e){
                if (e){
                    e.preventDefault();
                }
                let that = this;
                let path = "/api/customer_service/find_invoices_for_cs/"
                let data = {search_query: this.search_query}

                let s = function(response) {
                    if (response.data.result) {
                        that.searched_invoices = response.data.result;
                        // If only one invoice found, automatically show it
                        if (that.searched_invoices.length === 1) {
                            that.fetchFullInvoice(that.searched_invoices[0].invoice_id);
                        } else {
                            that.selected_invoice = null; // Clear selected invoice when multiple results
                        }
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                        that.searched_invoices = [];
                        that.selected_invoice = null;
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error searching invoices.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            fetch_items: function(value){
                let that = this;
                let path = "/api/customer_service/list_tickets/"
                let data = {type: this.list_option_type}

                let s = function(response) {
                    console.log(response)
                    if (response.data.result) {
                        let items = response.data.result;
                        that.items = items
                    }
                    else {
                        that.$bvToast.toast(
                            response.data.error,
                            {title: "Error", autoHideDelay: 1500, variant:"warning"}
                        );
                    }
                    that.items_being_loaded = false;
                }
                let f = function(error) {
                    console.log(error)
                    that.$bvToast.toast(
                        "Error loading tickets.",
                        {title: "Error", autoHideDelay: 1500, variant:"warning"}
                    );
                    that.items_being_loaded = false;
                }

                this.items = []
                this.items_being_loaded = true;
                Requestor.getSyncP(path, data, this, s, f);
            },
            
            sortby: function(key,mapper){
                if (this.sort_asc){
                    this.items = Requestor.sort(this.items,key,mapper)
                }
                else {
                    this.items = Requestor.sort_reverse(this.items,key,mapper)
                }
                this.sort_asc = !this.sort_asc;
            },
            
            fetch_prereqs: function(){
                this.fetch_items()
            },
        },
        created: function() {
            this.packet = JSON.parse(localStorage.packet);
            this.packet.userDetails = JSON.parse(localStorage.userDetails);
            this.packet.global_vars = global_vars;
            this.fetch_prereqs()
        }
    }
</script>

<style scoped>
    td {
        padding: 5px;
        font-size: 14px;
    }
    
    .invoice-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
        border-radius: 8px;
        margin-bottom: 20px;
    }
    
    .invoice-header h4 {
        margin: 0;
        color: white;
    }
    
    .invoice-header b {
        color: #ffd700;
    }
    
    @media print {
        .invoice-header {
            background: #f8f9fa;
            color: black;
            border: 1px solid #ddd;
        }
        
        .invoice-header b {
            color: #2c3e50;
        }
        
        .invoice-header button {
            display: none;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/CustomerService/CreateCustomerServiceTickets.vue